export default function transformObjectUppercase(obj) {
  const uppercaseObj = {};

  for (const [key, value] of Object.entries(obj)) {
    uppercaseObj[key.toUpperCase()] = value;
  }

  return uppercaseObj;
}
